/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How a competitor's submissions are turned into a problem score.
 * @export
 */
export const ScoringMode = {
    BestSubmission: 'best_submission',
    LastSubmission: 'last_submission',
    BestPerTestCase: 'best_per_test_case'
} as const;
export type ScoringMode = typeof ScoringMode[keyof typeof ScoringMode];


export function instanceOfScoringMode(value: any): boolean {
    for (const key in ScoringMode) {
        if (Object.prototype.hasOwnProperty.call(ScoringMode, key)) {
            if (ScoringMode[key as keyof typeof ScoringMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ScoringModeFromJSON(json: any): ScoringMode {
    return ScoringModeFromJSONTyped(json, false);
}

export function ScoringModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScoringMode {
    return json as ScoringMode;
}

export function ScoringModeToJSON(value?: ScoringMode | null): any {
    return value as any;
}

export function ScoringModeToJSONTyped(value: any, ignoreDiscriminator: boolean): ScoringMode {
    return value as ScoringMode;
}

